import React from 'react';
import { useTranslation } from 'react-i18next';
import BaggageIcon from '../Icons/BaggageIcon';

interface Props {
  toggleErrorModal(): void;
}

const DeactivationErrorModal: React.FC<Props> = ({ toggleErrorModal }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <div className="success-wrapper" data-testid="error-include-modal">
      <div className="icon-wrapper error">
        <BaggageIcon />
      </div>
      <span className="title-success error">{t('modalBeneficiariesDeactivation:lets_try_again')}</span>
      <span className="subtitle error">{t('modalBeneficiariesDeactivation:error_occurred')}</span>
      <button type="button" className="ok-button deactivate" onClick={toggleErrorModal}>
        {t('modalBeneficiariesDeactivation:try_again')}
      </button>
    </div>
  );
};

export default DeactivationErrorModal;
